import redo from './redo';
import undo from './undo';

export default {
  redo,
  undo,
};
